import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Image from "../image/Ethosflo_logo_black.png";
import MainPopup from "../popup-containers/MainPopup";
import PartnerRegistration from "../containers/PartnerRegistration";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import InvitePartnerPopup from "../popup-containers/InvitePartnerPopup";
import { IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";

const Headersection = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [invitePartnerPopup, setInvitePartnerPopup] = useState(false);
  const [userProfilePopUp, setUserProfilePopUp] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const childRef = useRef();
  const invitePartnerRef = useRef();
  const dropdownRef = useRef(null);
  const timeoutRef = useRef(null);

  const navLinks = [
    { id: "whyethosflo", label: "Why Ethosflo?" },
    { id: "assessmentmodules", label: "Assessment Modules" },
    { id: "howitworks", label: "How It Works?" },
    { id: "helpfulresources", label: "Helpful Resources" },
    { id: "dataprivacy", label: "Data Privacy" },
    { id: "frequentlyaskedquestions", label: "Frequently Asked Questions" },
    { id: "contactus", label: "Contact Us" },
  ];

  const scrollToSection = (id, offset = 80) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: y, behavior: "smooth" });
      window.history.pushState(null, "", `/${id}`);
    }
  };

  useEffect(() => {
    const path = window.location.pathname.slice(1);
    if (path) {
      setTimeout(() => scrollToSection(path), 100);
    }
  }, []);

  const handleInvitePartner = () => setInvitePartnerPopup(true);
  const handleCloseInvitePartner = () => {
    if (invitePartnerRef.current) invitePartnerRef.current.clearFormData();
    setInvitePartnerPopup(false);
    setIsLoading(false);
  };

  const handleSubmitInvitePartner = async () => {
    const formData = invitePartnerRef.current.validateAndGetFormData();
    if (formData.success) {
      setIsLoading(true);
      const payload = {
        ValueChainPartner: formData.data.VCPartner,
        VCPFirstName: formData.data.VCPContPersonFirstName,
        VCPLastName: formData.data.VCPContPersonLastName,
        VCPPosition: formData.data.VCPContPersonPosition,
        VCPEmail: formData.data.VCPContPersonEmail,
        VCPMobile: formData.data.VCPContPersonMobile,
        Company: formData.data.company,
        CFirstName: formData.data.companyInvPersonFirstName,
        CLastName: formData.data.companyInvPersonLastName,
        CPosition: formData.data.companyInvPersonPosition,
        CEmail: formData.data.companyInvPersonEmail,
        CMobile: formData.data.companyInvPersonMobile,
      };
      const response = await IUDAPI(payload, "PartnerAPI/IUDInvitePartner");
      if (response.data.Table[0].Result === "S") {
        toast.success("Mail sent successfully 👍", { duration: 2000, position: "top-center" });
        setTimeout(handleCloseInvitePartner, 2000);
      } else {
        toast.error("Failed to send mail 👎", { duration: 2000, position: "top-center" });
        setTimeout(handleCloseInvitePartner, 2000);
      }
    }
  };

  const handleClick = () => childRef.current.childFunction?.();
  const handleCancelClick = () => childRef.current.childCancelFunction?.();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current);
    setDropdownOpen(true);
  };
  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => setDropdownOpen(false), 3000);
  };

  return (
    <nav className="sticky top-0 z-50 w-full h-20 px-4 sm:px-6 md:px-10 bg-white shadow-sm font-sans">
      <div className="flex justify-between items-center">
        <div className="min-w-[100px]">
          <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            <img src={Image} alt="Ethosflo Logo" className="h-20 w-auto object-contain cursor-pointer" />
          </Link>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-4 text-sm md:text-base lg:text-lg font-medium text-gray-900">
          <div
            className="relative group"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            ref={dropdownRef}
          >
            <button className="hover:text-purple-700 transition">Home</button>
            {dropdownOpen && (
              <div className="absolute bg-white shadow-lg mt-2 rounded-md py-2 z-50 w-64">
                {navLinks.map((link, idx) => (
                  <button
                    key={idx}
                    onClick={() => scrollToSection(link.id)}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    {link.label}
                  </button>
                ))}
              </div>
            )}
          </div>

          <button className="hover:text-purple-700 transition" onClick={() => setUserProfilePopUp(true)}>
            Assessee Registration
          </button>

          <button className="hover:text-purple-700 transition" onClick={handleInvitePartner}>
            Invite Your Partners
          </button>

          <button className="hover:text-purple-700 transition" onClick={() => scrollToSection("helpfulresources")}>
            Resources
          </button>

          <button
            onClick={() => {
              sessionStorage.setItem("fromLogin", "true");
              navigate("/login", { replace: true }); 
            }}
            className="hover:text-purple-700 transition"
          >
            Login
          </button>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="flex flex-col space-y-1">
            {mobileMenuOpen ? (
              <div className="text-2xl font-bold">&times;</div>
            ) : (
              <>
                <span className="block w-6 h-0.5 bg-black"></span>
                <span className="block w-6 h-0.5 bg-black"></span>
                <span className="block w-6 h-0.5 bg-black"></span>
              </>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="absolute top-full left-0 w-full bg-white shadow-lg z-50 px-6 py-4 space-y-6 font-semibold max-h-[calc(100vh-5rem)] overflow-y-auto">
          <details className="group">
            <summary className="cursor-pointer hover:text-purple-700 transition font-semibold">Home</summary>
            <div className="pl-4 mt-2 space-y-2">
              {navLinks.map((link, idx) => (
                <button
                  key={idx}
                  onClick={() => {
                    scrollToSection(link.id);
                    setMobileMenuOpen(false);
                  }}
                  className="block text-gray-700 hover:text-purple-700"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </details>

          <div>
            <button
              className="block w-full text-left hover:text-purple-700 transition"
              onClick={() => {
                setUserProfilePopUp(true);
                setMobileMenuOpen(false);
              }}
            >
              Assessee Registration
            </button>
          </div>

          <div>
            <button
              className="block w-full text-left hover:text-purple-700 transition"
              onClick={() => {
                handleInvitePartner();
                setMobileMenuOpen(false);
              }}
            >
              Invite Partners
            </button>
          </div>

          <div>
            <button
              className="block w-full text-left hover:text-purple-700 transition"
              onClick={() => {
                scrollToSection("helpfulresources");
                setMobileMenuOpen(false);
              }}
            >
              Resources
            </button>
          </div>

          <div>
          <button
            onClick={() => {
              sessionStorage.setItem("fromLogin", "true");
              navigate("/login", { replace: true }); 
            }}
            className="hover:text-purple-700 transition"
          >
            Login
          </button>
          </div>
        </div>
      )}


      {/* Assessee Registration Popup */}
      <MainPopup
        popUpOpen={userProfilePopUp}
        setpopUpOpen={setUserProfilePopUp}
        loginPopups={true}
        widthAdjustment={true}
      >
        <div>
          <PopUpScreenTitle
            title="Assessee Registration"
            setpopUpOpen={() => setUserProfilePopUp(false)}
            hederDetails={() => setUserProfilePopUp(false)}
          />
          <PartnerRegistration ref={childRef} closePopup={() => setUserProfilePopUp(false)} />
        </div>
        <PopUpButtons
          submitDetails={handleClick}
          handleSubmit={handleClick}
          cancel={handleCancelClick}
          disabledBtn={false}
        />
      </MainPopup>

      {/* Invite Partner Popup */}
      <MainPopup
        popUpOpen={invitePartnerPopup}
        setpopUpOpen={setInvitePartnerPopup}
        loginPopups={true}
        widthAdjustment={true}
      >
        <div>
          <PopUpScreenTitle
            title="Invite Your Partners"
            setpopUpOpen={setInvitePartnerPopup}
            hederDetails={true}
          />
          <InvitePartnerPopup ref={invitePartnerRef} closePopup={handleCloseInvitePartner} isLoading={isLoading} />
        </div>
        <PopUpButtons
          buttonLabel="Send Mail"
          submitDetails={true}
          handleSubmit={handleSubmitInvitePartner}
          cancel={handleCloseInvitePartner}
          disabledBtn={isLoading}
        />
      </MainPopup>
    </nav>
  );
};

export default Headersection;
